import { render } from "./ExamCell2.vue?vue&type=template&id=67cae890&scoped=true"
import script from "./ExamCell2.vue?vue&type=script&lang=js"
export * from "./ExamCell2.vue?vue&type=script&lang=js"

import "./ExamCell2.vue?vue&type=style&index=0&id=67cae890&scoped=true&lang=css"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67cae890"]])

export default __exports__